import Vue from 'vue';
import Notification from './notification';

const wrapperinstances = {};
const types = ['success', 'warning', 'info', 'error'];

function getWrapPosition(position, offset = 14) {
  let style;
  offset = isNaN(offset) ? offset : `${offset}px`;

  switch (position) {
    case 'top-right':
      style = {
        top: offset,
        right: '16px',
      };
      break;
    case 'top-left':
      style = {
        top: offset,
        left: '16px',
      };
      break;
    case 'bottom-right':
      style = {
        bottom: offset,
        right: '16px',
      };
      break;
    case 'bottom-left':
      style = {
        bottom: offset,
        left: '16px',
      };
      break;
    default:
      style = {
        top: '14px',
        right: '16px',
      };
  }
  return style;
}

// 获取 notice 外围容器实例
function getNoticesWrapperIns({ position = 'top-right', offset = 14 }) {
  const id = `notification_wrap_${position}`;

  if (wrapperinstances[id]) {
    return wrapperinstances[id];
  }

  const style = getWrapPosition(position, offset);

  const attrs = {
    style,
    class: 'ten-notification_wrap',
  };

  const Profile = Vue.extend({
    render() {
      return (
        <div {...attrs} />
      );
    },
  });

  const container = new Profile().$mount().$el;

  wrapperinstances[id] = container;

  document.body.appendChild(container);

  return container;
}

function notification(options) {
  options.position = options.position || 'top-right';
  const NoticeConstructor = Vue.extend(Notification);

  const wrapper = getNoticesWrapperIns(options);
  const instance = new NoticeConstructor({ propsData: options });

  instance.visible = true;

  instance.$mount();

  if (options.position.indexOf('bottom') > -1) {
    wrapper.insertBefore(instance.$el, wrapper.firstChild);
  } else {
    wrapper.appendChild(instance.$el);
  }
}

types.forEach((type) => {
  notification[type] = args => notification({
    ...args,
    type,
  });
});

export default notification;
